var exports = {
  "k": "xe533113f--f50e3b--container",
};

module.exports = exports;
